export const fightcampHolidayBundle = {
  title: 'FightCamp All-in-One Bundle',
  id: 'fightcamp_holiday_bundle',
  price: 169900,
  category: 'package',
  img_url: 'https://a.storyblok.com/f/152150/933x933/9946fe2180/holiday-bundle.jpg',
  fbid: '',
};
